import React from 'react';
import { ArrowUpRight, Mail, MessageCircle, Phone } from 'lucide-react';
import { CONTACT_EMAIL, CONTACT_PHONE, WHATSAPP_LINK } from '../../constants';
import { Logo } from '../Logo';

export const MarketingFooter: React.FC = () => {
  return (
    <footer className="marketing-shell marketing-footer">
      <div className="marketing-footer__grid">
        <div className="marketing-footer__brand">
          <a href="/" aria-label="Áncora Automations — Inicio">
            <Logo variant="light" />
          </a>
          <p>Atiende a tus clientes y se ocupa de sus gestiones.</p>
          <a className="marketing-footer__diagnostic" href="/#contacto">
            Cuéntanos qué necesitas
            <ArrowUpRight aria-hidden="true" size={18} />
          </a>
        </div>

        <div>
          <h2>Producto</h2>
          <ul>
            <li><a href="/#como-gestiona">Qué hace Áncora</a></li>
            <li><a href="/#integraciones">Integraciones</a></li>
            <li><a href="/#casos">Casos reales</a></li>
            <li><a href="/#pricing">Precio claro</a></li>
            <li><a href="/quienes-somos">Quiénes somos</a></li>
            <li><a href="/preguntas-frecuentes">Preguntas frecuentes</a></li>
          </ul>
        </div>

        <div>
          <h2>Recursos</h2>
          <ul>
            <li><a href="/blog/">Guías y análisis</a></li>
            <li><a href="/integraciones-software-ia/">Software e integraciones</a></li>
            <li><a href="/clinicas-centros-agenda/">Clínicas y agenda</a></li>
            <li><a href="/centros-estetica-belleza/">Estética y belleza</a></li>
            <li><a href="/agentes-ventas-ia/">Ventas con IA</a></li>
            <li><a href="/privacidad">Política de privacidad</a></li>
            <li><a href="/eliminacion-datos">Eliminación de datos</a></li>
          </ul>
        </div>

        <div>
          <h2>Contacto</h2>
          <ul className="marketing-footer__contact">
            <li>
              <Mail aria-hidden="true" size={17} />
              <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
            </li>
            <li>
              <Phone aria-hidden="true" size={17} />
              <a href={`tel:${CONTACT_PHONE.replace(/\s/g, '')}`}>{CONTACT_PHONE}</a>
            </li>
            <li>
              <MessageCircle aria-hidden="true" size={17} />
              <a href={WHATSAPP_LINK} target="_blank" rel="noreferrer">WhatsApp</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="marketing-footer__bottom">
        <p>© {new Date().getFullYear()} ANCORA AUTOMATIONS</p>
        <div aria-label="Información legal">
          <a href="/privacidad">Política de Privacidad</a>
          <a href="/eliminacion-datos">Eliminación de Datos</a>
          <a href="/condiciones-comerciales.html">Condiciones comerciales</a>
        </div>
      </div>
    </footer>
  );
};
